import { queryOptions } from "@tanstack/react-query";
import { InsightsSchemas, InternalInsightsSchemas } from "@wayflyer/api-types";
import { axiosClient as axios } from "@wayflyer/auth-sdk";

export const insightsRouteDataQuery = (customerDomain: string) =>
  queryOptions({
    queryKey: ["insights", "route-data", customerDomain] as const,
    queryFn: () => axios.get<InsightsSchemas.RouteData>(`/${customerDomain}/insights/api/route-data/`),
    select: (response) => response.data,
  });

export const internalInsightsRouteDataQuery = (customerDomain: string) =>
  queryOptions({
    queryKey: ["internal-insights", "route-data", customerDomain] as const,
    queryFn: () =>
      axios.get<InternalInsightsSchemas.InternalRouteData>(`/${customerDomain}/insights/internal-api/route-data/`),
    select: (response) => response.data,
  });
